module.exports = __webpack_public_path__ + "static/media/faq-1800.04b5bbfb.jpg";